module.exports = __webpack_public_path__ + "img/gravier_roule_challans.c9bdab72.jpg";